export const endpoints = {
  searchSubscriberGroups: 'subscriberGroup/search',
  userMemberOptions: 'subscriberGroup/userMember/options'
};
